module.exports = __webpack_public_path__ + "static/media/Hero-bg.4808be6e.jpg";